/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_ForbiddenInputs */

const en_adm_err_forbidden = /** @type {(inputs: Adm_Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to do this.`)
};

const de_adm_err_forbidden = /** @type {(inputs: Adm_Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dazu hast du keine Berechtigung.`)
};

/**
* | output |
* | --- |
* | "You do not have permission to do this." |
*
* @param {Adm_Err_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_forbidden = /** @type {((inputs?: Adm_Err_ForbiddenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_ForbiddenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_forbidden(inputs)
	return en_adm_err_forbidden(inputs)
});